


import React, { useEffect, useState } from 'react';
import ManagerHeader from './ManagerHeader';
import Navbar from './Navbar';

const InfluencerAffiliateEarnings = () => {
  const [influencerData, setInfluencerData] = useState([]);

  useEffect(() => {
    fetch("https://server-side-influencer.onrender.com/manager/all-influencer-affilatesdata")
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setInfluencerData(data.data);
        }
      })
      .catch(err => console.error("Fetch error:", err));
  }, []);

  return (
    <div className="flex h-screen justify-center items-start w-full bg-white">
      {/* Sidebar */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      {/* Main */}
      <div className="h-screen ml-0 w-full overflow-y-auto">
        {/* Header */}
        <div className="fixed top-0 left-0 right-0 z-10 bg-white shadow-md">
          <ManagerHeader page="influencers earnings" />
        </div>

        {/* Content */}
        <div className="mt-[100px] px-6">
          {/* Title */}
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-6 text-center mt-6">
            Influencer Affiliate Clicks and Earnings
          </h2>

          {/* Table */}
          <div className="overflow-x-auto bg-white rounded-lg shadow border border-gray-200 mt-2">
            <table className="min-w-full text-sm text-center">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-4 py-3 border">Profile</th>
                  <th className="px-4 py-3 border">Name</th>
                  <th className="px-4 py-3 border">Total Clicks</th>
                  <th className="px-4 py-3 border">Total Commission (₹)</th>
                  <th className="px-4 py-3 border">Total Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                {influencerData.length > 0 ? (
                  influencerData.map((item) => (
                    <tr key={item.influencerId} className="hover:bg-gray-50 transition">
                      <td className="px-4 py-2 border">
                        <img
                          src={item.profilepic}
                          alt="profile"
                          className="w-10 h-10 rounded-full object-cover mx-auto"
                        />
                      </td>
                      <td className="px-4 py-2 border">{item.fullname || item.name}</td>
                      <td className="px-4 py-2 border">{item.totalClicks}</td>
                      <td className="px-4 py-2 border">₹ {item.totalCommission}</td>
                      <td className="px-4 py-2 border">₹ {item.totalAmount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-gray-500 py-4">
                      No influencer data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfluencerAffiliateEarnings;
